module.exports = __webpack_public_path__ + "static/media/Rocket Boy.0e3897e1.jpg";